require('../bootstrap');
import * as func from '../functions';

$(document).ready(function() {

    $(document).on('click', '#go-to-cars-list', function(e) {
        e.preventDefault();

        var url = '';

		if ($('.search-body-type.active').length > 0) {
			url += (url != '' ? '&bt=' + $('.search-body-type.active').data('id') : '?bt=' + $('.search-body-type.active').data('id'));
		}
		if ($('#search-brand option:selected').val() != '') {
			url += (url != '' ? '&b=' + $('#search-brand option:selected').val() : '?b=' + $('#search-brand option:selected').val());
		}
		if ($('#search-model option:selected').val() != '') {
			url += (url != '' ? '&m=' + $('#search-model option:selected').val() : '?m=' + $('#search-model option:selected').val());
		}
		if ($('#search-price option:selected').val() != '') {
			url += (url != '' ? '&fp=' + $('#search-price option:selected').val() : '?fp=' + $('#search-price option:selected').val());
		}
		if ($('#search-year option:selected').val() != '') {
			url += (url != '' ? '&fy=' + $('#search-year option:selected').val() : '?fy=' + $('#search-year option:selected').val());
		}

        window.location = carListPage + url;
    });

    $(document).on('click', '.search-body-type', function(e) {
        e.preventDefault();
        var id = $(this).data('id');

		$('.search-body-type').not(this).removeClass('active');
		$('.search-body-type').not(this).each(function(index, item) {
			var img = $(this).find('img');
			var src = $(img).data('src');
			$(img).attr('src', src);
		});

		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			var thisImg = $(this).find('img');
			var hoverSrc = $(thisImg).data('src');
			$(thisImg).attr('src', hoverSrc);
		} else {
			$(this).addClass('active');
			var thisImg = $(this).find('img');
			var hoverSrc = $(thisImg).data('src-hover');
			$(thisImg).attr('src', hoverSrc);
		}
    });

	$('.search-body-type').hover(function() {
		var thisImg = $(this).find('img');
		var hoverSrc = $(thisImg).data('src-hover');
		$(thisImg).attr('src', hoverSrc);
	},
	function() {
		if ($(this).hasClass('active')) {
			return;
		}
		var thisImg = $(this).find('img');
		var src = $(thisImg).data('src');
		$(thisImg).attr('src', src);
	});

	$(document).on('change', '#search-brand', function() {
		$('#search-model').find('option').slice(2).remove();

		if ($('#search-brand option:selected').val() == '') {
			$('#search-model').prop("disabled", true);
			return;
		}

		$('#search-model').prop("disabled", false);
		var models = $('#search-brand option:selected').data('models');

		for(var i in models) {
			$('#search-model').append('<option value="'+models[i].id+'">'+models[i].name+'</option>');
		}
	});
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/search.js